import React from 'react';

const RsrLogo = ({ showText = true }) => (
  <div style={{ textAlign: 'center' }}>
    <div style={{
      color: '#E22D2D',
      fontWeight: '800',
      fontSize: '28px',
      fontStyle: 'italic',
      letterSpacing: '2px',
      lineHeight: 1
    }}>
      RSR
    </div>
    <div style={{
      background: '#3B3A8F',
      color: 'white',
      fontSize: '9px',
      fontWeight: '600',
      padding: '2px 8px',
      letterSpacing: '1px',
      marginTop: '3px',
      borderRadius: '2px'
    }}>
      INTERNATIONAL
    </div>
    {showText && (
      <div style={{
        color: 'rgba(255,255,255,0.4)',
        fontSize: '9px',
        marginTop: '6px',
        letterSpacing: '0.3px'
      }}>
        Khyati Portal · ERP
      </div>
    )}
  </div>
);

export default RsrLogo;
